<template>
  <div>
    <!-- header -->
    <PageHeader
      :title="$t('integrations.title')"
      className="d-flex align-items-center justify-content-between"
    >
    </PageHeader>
    <section class="wrapper integration-wrapper">
      <div class="content">
        <b-form id="form" novalidate @submit.prevent="onSubmit">
          <div class="input-wrapper" style="width: 416px">
            <!-- <div
              class="form-group m-d-gruop"
              :class="{ 'invalid-field': form.name && getErrMsg }"
            >
              <b-form-input
                id="integrationName"
                name="integration-name"
                type="text"
                v-model="form.name"
                required
                @input="validateName($event)"
              />
              <label
                for="integrationName"
                class="intName"
                :class="{ 'itnName-type': !!form.name }"
                >Integration Name</label
              >
              
            </div>
            <div class="err-wrapper "  style="margin-bottom: 24px;">
              <div class="text-danger" v-if="!$v.form.name.error">
                <span
                  class="font-weight-bolder"
                  v-if="submitted && !$v.form.name.required"
                  >Integration Name is required.</span
                >
                <span class="font-weight-bolder" v-if="submitted && form.name.length > 30"
                  >The maximum length is 30 characters.</span
                >
                

                <span
                  class="font-weight-bolder"
                  
                  v-if="form.name && getErrMsg"
                  >{{ getErrMsg }}</span
                >
              </div>
            </div> -->
            <!-- new input -->
            <b-form-group>
              <vp-input
                id="integrationNam"
                v-model="form.name"
                :label="$t('integrations.grid.integrationName')"
                @input="validateName($event)"
                width="416"
                :invalid="
                  getErrMsg.length > 0 ||
                  $v.form.name.error ||
                  form.name.length > 30
                "
              />
              <div
                class="err-wrapper"
                style="margin-top: 8px; padding-inline-start: 20px"
              >
                <div class="text-danger" v-if="!$v.form.name.error">
                  <span
                    class="font-weight-bolder"
                    style="padding-inline-start: 0px !important"
                    v-if="submitted && !$v.form.name.required"
                    >{{ $t("integrations.integrationNameRequired") }}</span
                  >
                  <span
                    class="font-weight-bolder"
                    style="padding-inline-start: 0px !important"
                    v-if="form.name.length > 30"
                    >{{ $t("common.notes.maxLength") }}</span
                  >

                  <span
                    style="padding-inline-start: 0px !important"
                    class="font-weight-bolder"
                    v-if="form.name && getErrMsg"
                    >{{ getErrMsg }}</span
                  >
                </div>
              </div>
            </b-form-group>
          </div>
          <p class="access-permission">
            {{ $t("journeyBuilder.form.accessPermission") }}
          </p>
          <p class="admin-permission">
            {{ $t("integrations.adminPermission") }}
          </p>
          <div class="int-dropDown">
            <!-- <multiselect
              class="custom-tag"
              :class="{ isActive: selectedSite.length > 0 }"
              id="site"
              v-model="selectedSite"
              :options="sitesOptions"
              track-by="id"
              placeholder="Select sites"
              :show-labels="false"
              label="name"
              :allowEmpty="true"
              multiple
            >
            </multiselect> -->

            <!-- <span class="selections-label" v-if="selectedSite && selectedSite.length > 0">
              Select sites
            </span> -->
            <!-- <multiselect
              class="select-sites"
              id="int-site"
              v-model="selectedSite"
              :options="sitesOptions"
              track-by="id"
              placeholder="Select sites"
              :show-labels="false"
              label="name"
              :allowEmpty="true"
              multiple
              @input="siteChanged"
            >
            </multiselect> -->
            <vp-treeselect
              v-model="selectedSite"
              @input="siteChanged"
              :label="$t('common.site')"
              :showPlaceholderIcon="true"
              :options="sitesOptions"
              :isMultiple="true"
              :width="'416'"
            />

            <p
              class="removing-notAllawed-one"
              v-if="
                getIsEdit &&
                getIntgData.sites.find((x) => !!x.disabled) &&
                !getIntgData.has_attendance_mode
              "
            >
              <strong class="bold-text">{{ $t("common.notes.note") }}:</strong>
              {{ $t("integrations.removingSitesNotAllowed") }}
            </p>

            <p
              class="removing-notAllawed-one"
              v-else-if="
                ((getModalInfo && getModalInfo.code === 'wonde') ||
                  getIntgData.dir_code === 'wonde') &&
                getIsEdit &&
                getIntgData.sites.find((x) => !!x.disabled) &&
                !!getIntgData.has_attendance_mode
              "
            >
              <strong class="bold-text">{{ $t("common.notes.note") }}:</strong>
              {{ $t("integrations.removingSitesNotAllowed") }}
              {{ $t("integrations.integrationLinkedToAttendanceMode") }}
            </p>

            <p
              class="removing-notAllawed-one"
              v-else-if="
                ((getModalInfo && getModalInfo.code === 'wonde') ||
                  getIntgData.dir_code === 'wonde') &&
                getIsEdit &&
                getIntgData.sites.filter((x) => !x.disabled).length ==
                  getIntgData.sites.length &&
                !!getIntgData.has_attendance_mode
              "
            >
              {{ $t("common.notes.note") }}:
              {{ $t("integrations.integrationLinkedToAttendanceMode") }}
            </p>

            <div
              class="text-danger"
              style="margin-top: 12px !important"
              v-if="submitted && selectedSite.length == 0"
            >
              <span class="font-weight-bolder second">{{
                $t("integrations.siteRequired")
              }}</span>
            </div>
          </div>
          <hr class="h-line" style="margin-top: 45px; margin-bottom: 41px" />

          <template
            v-if="
              data.sync_options &&
              data.sync_options.dir_sync_options &&
              data.sync_options.dir_sync_options.length > 1
            "
          >
            <div>
              <h5 class="dark-grey-synced">
                {{ $t("integrations.syncedData") }}
              </h5>
            </div>
            <div style="margin-bottom: 46px">
              <v-radio-group v-model="syncedData">
                <v-radio
                  v-for="option in sync_options"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </div>
          </template>

          <template
            v-if="option && option.code == 'usersAndScansAndAttendance'"
          >
            <div>
              <h5 class="dark-grey-synced">
                {{ $t("integrations.scanSetting") }}
              </h5>
            </div>
            <div style="margin-bottom: 46px">
              <v-radio-group v-model="scanSettingVal">
                <v-radio
                  v-for="option in scan_settings"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </div>
          </template>

          <div
            v-if="
              write_back &&
              option &&
              option.code == 'usersAndScansAndAttendance'
            "
          >
            <h5 class="mb-4 light-grey" style="margin-bottom: 32px">
              {{ $t("integrations.syncBack") }} Wonde
            </h5>
            <switches
              v-model="writeBackValue"
              theme="bootstrap"
              color="none"
            ></switches>
            <div v-if="writeBackValue" style="margin-top: 37px">
              <div>
                <h5 class="mb-4 light-grey" style="margin-bottom: 32px">
                  {{ $t("integrations.autoWriteBack") }} Wonde
                </h5>
                <div style="margin-bottom: 46px">
                  <v-radio-group v-model="autoWriteBackValue">
                    <v-radio
                      v-for="option in automatic_write"
                      :key="option.value"
                      :label="option.text"
                      :value="option.value"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>

          <template>
            <div
              v-show="
                option &&
                option.code != 'usersAndScansAndAttendance' &&
                sync_settings &&
                sync_settings.length > 0
              "
            >
              <div>
                <h5 class="dark-grey-directory">
                  {{ $t("integrations.syncSetting") }}
                </h5>
                <h5 class="light-grey" style="margin-bottom: 32px">
                  {{ $t("integrations.syncSettingDesc") }}
                </h5>
              </div>
              <div style="margin-bottom: 46px">
                <v-radio-group v-model="syncValue">
                  <v-radio
                    v-for="option in sync_settings"
                    :key="option.value"
                    :label="option.text"
                    :value="option.value"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
          </template>
          <hr
            v-if="sync_photos"
            class="h-line"
            style="margin-top: 41px; margin-bottom: 41px"
          />
          <div v-if="sync_photos">
            <h5 class="dark-grey-photo">{{ $t("integrations.syncPhotos") }}</h5>
            <div>
              <h5 class="light-grey" style="margin-bottom: 37px">
                {{ $t("integrations.syncPhotosDesc") }}
              </h5>
              <switches
                v-model="syncPhotosValue"
                theme="bootstrap"
                color="none"
              ></switches>
            </div>
            <div v-if="syncPhotosValue">
              <div>
                <h5
                  class="light-grey"
                  style="margin-bottom: 32px; margin-top: 37px"
                >
                  {{ $t("integrations.validatePhotos") }}
                </h5>
                <div style="margin-bottom: 46px">
                  <v-radio-group v-model="validatePhotoValue">
                    <v-radio
                      v-for="option in validate_photos"
                      :key="option.value"
                      :label="option.text"
                      :value="option.value"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </div>

              <div>
                <h5
                  class="light-grey"
                  style="margin-bottom: 32px; margin-top: 37px"
                >
                  {{ $t("integrations.importPhotos") }}
                </h5>
                <div style="margin-bottom: 46px">
                  <v-radio-group v-model="importPhotoActionValue">
                    <v-radio
                      v-for="option in import_photo_action"
                      :key="option.value"
                      :label="option.text"
                      :value="option.value"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>
          <hr class="h-line" style="margin-top: 41px; margin-bottom: 41px" />
          <template v-if="delete_handling && delete_handling.length > 0">
            <div>
              <h5 class="dark-grey-handling">
                {{ $t("integrations.deleteHandling") }}
              </h5>
              <h5 class="light-grey" style="margin-bottom: 37px">
                {{ $t("integrations.deleteHandlingDesc") }}
              </h5>
            </div>
            <div style="margin-bottom: 46px">
              <v-radio-group v-model="deletionValue">
                <v-radio
                  v-for="option in delete_handling"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </div>
          </template>

          <hr class="h-line" style="margin-top: 41px; margin-bottom: 41px" />

          <div>
            <div
              class="d-flex flex-row"
              style="margin-bottom: 47px; align-items: center"
            >
              <h5
                class="dark-grey-mapping mapping-title"
                style="margin-bottom: 0px"
              >
                {{ $t("integrations.mapping") }}
              </h5>
              <button
                class="refresh-btn btn btn-primary"
                v-if="getIsEdit"
                type="button"
                @click="onRefreshMapping()"
                :disabled="
                  getUsersWithDuplicatesCount > 0 ||
                  getUsersWithErrsCount > 0 ||
                  !getIntgData.can_edit
                "
              >
                <svg
                  width="11"
                  height="12"
                  viewBox="0 0 11 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7735 0.232341C10.6396 0.095301 10.4195 -0.00747907 10.2277 0.000427092C10.0282 0.00965094 9.82095 0.0768533 9.68194 0.232341C9.54293 0.386511 9.4554 0.577577 9.4554 0.791043C9.4554 1.0443 9.4554 1.29677 9.4554 1.54964C9.19449 1.32761 8.91466 1.12864 8.619 0.956413C7.75454 0.453055 6.76934 0.186881 5.76973 0.186881C4.99112 0.186881 4.23542 0.343159 3.52362 0.651367C2.83653 0.948903 2.21959 1.37465 1.68992 1.91688C1.16025 2.45911 0.744369 3.09068 0.453726 3.79407C0.152658 4.52275 0 5.29637 0 6.09344C0 6.89051 0.152658 7.66413 0.453726 8.39281C0.744369 9.0962 1.16025 9.72777 1.68992 10.27C2.21959 10.8122 2.83653 11.238 3.52362 11.5355C4.23542 11.8437 4.99112 12 5.76973 12C7.01055 12 8.19307 11.6027 9.18934 10.8511C9.5298 10.5943 9.60252 10.1034 9.35153 9.75478C9.10053 9.40612 8.62119 9.3318 8.2806 9.58875C7.54936 10.1403 6.68117 10.4319 5.7696 10.4319C3.43287 10.4319 1.53173 8.48571 1.53173 6.09344C1.53173 3.70117 3.43287 1.75494 5.76973 1.75494C6.83357 1.75494 7.82996 2.15341 8.5957 2.85719C8.32411 2.85719 8.05252 2.85719 7.7808 2.85719C7.66624 2.85719 7.55168 2.85719 7.43712 2.85719C7.2389 2.85719 7.03166 2.94547 6.89136 3.0891C6.7575 3.22614 6.6571 3.45147 6.66482 3.6478C6.67383 3.85204 6.73948 4.06419 6.89136 4.2065C7.04196 4.34881 7.2286 4.43842 7.43712 4.43842C7.75119 4.43842 8.06397 4.43842 8.37804 4.43842C8.88004 4.43842 9.38203 4.43842 9.88403 4.43842C9.99858 4.43842 10.1131 4.43842 10.2277 4.43842C10.6447 4.43842 11 4.07605 11 3.6478C11 3.32628 11 3.00608 11 2.68457C11 2.17067 11 1.65677 11 1.14287C11 1.02559 11 0.908318 11 0.791043C11 0.588118 10.9138 0.37597 10.7735 0.232341Z"
                    fill="white"
                  />
                </svg>
                {{ $t("integrations.refresh") }}
              </button>
            </div>
            <p
              class="note"
              v-if="
                getIsEdit &&
                (getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0)
              "
            >
              <b>{{ $t("common.notes.note") }}:</b>
              {{ $t("integrations.sorry") }}
              {{
                (this.getModalInfo && this.getModalInfo.code === "wonde") ||
                this.getIntgData.dir_code === "wonde"
                  ? $t("integrations.gradesOrStaff")
                  : $t("integrations.orGroups")
              }}
              {{ $t("integrations.pleaseGo") }}
              <router-link
                :to="`/view-integration/${getIntegId}/${getIntgData.name}`"
              >
                <a> {{ $t("integrations.integrationPage") }}</a>
              </router-link>
              {{ $t("integrations.toCheck") }}
            </p>
            <p class="note" v-else-if="getIsEdit && !getIntgData.can_edit">
              <b>{{ $t("common.notes.note") }}:</b>
              {{ $t("integrations.sorry") }}
              {{
                (this.getModalInfo && this.getModalInfo.code === "wonde") ||
                this.getIntgData.dir_code === "wonde"
                  ? $t("integrations.gradesOrStaff")
                  : $t("integrations.orGroups")
              }}
              {{ $t("integrations.cantEdit") }}
            </p>
          </div>
          <b-row class="mb-4">
            <b-col cols="5">
              <h4 class="upper-case">{{ getModalInfo.name }}</h4>
            </b-col>
            <b-col cols="2" class="d-flex flex-column"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :style="{ transform: getLanguage === 'ar' ? 'scaleX(-1)' : '' }"
              >
                <path
                  d="M16.5095 6.05082e-07H7.49051C6.17556 -0.000528074 4.88366 0.345394 3.74474 1.00273C2.60581 1.6602 1.6602 2.60582 1.00273 3.74474C0.34543 4.88366 -0.000495637 6.17556 6.05082e-07 7.49051V16.5095C-0.000528074 17.8244 0.345394 19.1163 1.00273 20.2553C1.6602 21.3942 2.60581 22.3398 3.74474 22.9973C4.88366 23.6546 6.17556 24.0005 7.49051 24H16.5095C17.8244 24.0005 19.1163 23.6546 20.2553 22.9973C21.3942 22.3398 22.3398 21.3942 22.9973 20.2553C23.6546 19.1163 24.0005 17.8244 24 16.5095V7.49051C24.0005 6.17556 23.6546 4.88366 22.9973 3.74474C22.3398 2.60582 21.3942 1.6602 20.2553 1.00273C19.1163 0.345431 17.8244 -0.000495637 16.5095 6.05082e-07ZM17.899 13.0534L13.3516 17.6008C12.9906 17.9619 12.4643 18.1029 11.9711 17.9707C11.478 17.8385 11.0928 17.4533 10.9606 16.9601C10.8285 16.467 10.9695 15.9408 11.3305 15.5797L13.5158 13.4147H7.10891C6.59981 13.4147 6.12946 13.1431 5.87484 12.7022C5.62038 12.2615 5.62038 11.7183 5.87484 11.2774C6.12948 10.8365 6.59981 10.565 7.10891 10.565H13.4852L11.3353 8.41258C10.9742 8.0515 10.8332 7.5253 10.9654 7.03222C11.0975 6.53895 11.4828 6.15373 11.9758 6.0216C12.4691 5.88943 12.9953 6.03041 13.3562 6.39149L17.9036 10.9389C18.1834 11.2192 18.3327 11.6041 18.3154 11.9999V12.0454C18.3163 12.4236 18.1661 12.7862 17.8986 13.0534L17.899 13.0534Z"
                  fill="black"
                />
              </svg>
            </b-col>
            <b-col cols="5">
              <h4 style="margin-inline-start: 200px" class="upper-case">
                {{ $t("integrations.visipointDir") }}
              </h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="5">
              <h6 class="dark-grey mapping-title">
                {{
                  (this.getModalInfo && this.getModalInfo.code === "wonde") ||
                  this.getIntgData.dir_code === "wonde"
                    ? $t("integrations.students")
                    : $t("integrations.usersFields")
                }}
              </h6>
            </b-col>
            <b-col cols="2"></b-col>
            <b-col cols="5">
              <h6
                class="dark-grey-two mapping-title"
                style="margin-inline-start: 202px"
              >
                {{ $t("integrations.usersFields") }}
              </h6>
            </b-col>
          </b-row>
          <div
            v-for="field in textFields"
            :key="field.id"
            class="d-flex justify-content-between mb-3 mapping-fields"
          >
            <b-input-group class="width-416">
              <label
                v-b-tooltip.hover
                v-bind:title="field.display_Name"
                :class="{
                  'disable-field':
                    getUsersWithDuplicatesCount > 0 ||
                    getUsersWithErrsCount > 0 ||
                    (getIntgData && getIntgData.can_edit),
                }"
              >
                <span class="int-span">{{ field.display_Name }}</span>
              </label>
              <b-form-input
                v-b-tooltip.hover="field.example_data"
                class="width-416"
                :value="field.example_data"
                readonly
                :class="{
                  'disable-field':
                    getUsersWithDuplicatesCount > 0 ||
                    getUsersWithErrsCount > 0 ||
                    (getIntgData && getIntgData.can_edit),
                }"
              />
            </b-input-group>
            <!-- <b-tooltip
            :target="field.example_data"
            >
              
            </b-tooltip> -->
            <!-- <Dropdown
              :selectedValues="dropdownValues"
              :items="dropdownItems"
              @change="dropdownChangeHanlder(field.id, $event)"
            /> -->
            <!-- <b-form-select
              @change="dropdownChangeHanlder(field.id, $event)"
              v-model="field.bindValue"
              style="padding-inline-start: 20px"
              class="width-422 height-55 mapping-select"
              :class="{
                'disable-field':
                  getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0,
              }"
              :disabled="
                getIsEdit &&
                (getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0)
              "
            >
              <template v-for="item in dropdownItems">
                <b-form-select-option
                  :key="item.id"
                  :value="item.id"
                  :disabled="dropdownValues.includes(item.id)"
                  >{{ item.display_Name }}
                </b-form-select-option>
              </template>
            </b-form-select> -->
            <vp-treeselect
              v-model="field.bindValue"
              @input="dropdownChangeHanlder(field.id, $event)"
              @select="selectHandler($event, field)"
              :label="$t('integrations.selectUser')"
              class="integration-dropdown"
              :showPlaceholderIcon="false"
              :options="dropdownItemsFinal"
              :isMultiple="false"
              :width="'416'"
              :disabled="
                getIsEdit &&
                (getUsersWithDuplicatesCount > 0 ||
                  getUsersWithErrsCount > 0 ||
                  !getIntgData.can_edit)
              "
            />
          </div>
          <div
            class="text-danger"
            v-if="submitted && !$v.form.dirMapValuesArray.required"
          >
            <span class="font-weight-bolder">{{
              $t("integrations.oneField")
            }}</span>
          </div>

          <!-- <div style="margin: auto; width: 100%; text-align: center" v-if="!getIsEdit">
            <p class="note-center">
              <b>{{ $t("common.notes.note") }}:</b> {{ $t("integrations.ignoredNote") }}
            </p>
            <hr class="h-line" style="margin-top: 50px; margin-bottom: 42px" />
          </div> -->

          <template v-if="allDirAreas.length == 0">
            <div v-if="option && option.code == 'usersAndScansAndAttendance'">
              <b-row>
                <b-col cols="5">
                  <h6 class="dark-grey mapping-title">
                    {{ $t("integrations.areas") }}
                  </h6>
                </b-col>
              </b-row>
              <!-- AREAS DROPDOWN -->
              <div class="int-selectarea">
                <div class="field-container">
                  <vp-treeselect
                    @input="areaChanged"
                    v-model="selectedArea"
                    :label="$t('integrations.selectArea')"
                    class="integration-dropdown"
                    :showPlaceholderIcon="false"
                    :options="getSelectedSitesAreas"
                    :isMultiple="false"
                    :width="'416'"
                    :isLoading="isLoading"
                    :disabled="
                      getIsEdit &&
                      (getUsersWithDuplicatesCount > 0 ||
                        getUsersWithErrsCount > 0 ||
                        !getIntgData.can_edit ||
                        (getSelectedSitesAreas.find(
                          (item) => item.id == selectedArea
                        ) &&
                          getSelectedSitesAreas.find(
                            (item) => item.id == selectedArea
                          ).isDisabled))
                    "
                  />
                  <p
                    class="removing-notAllawed-one"
                    v-if="
                      getSelectedSitesAreas.find(
                        (item) => item.id == selectedArea
                      ) &&
                      getSelectedSitesAreas.find(
                        (item) => item.id == selectedArea
                      ).isDisabled
                    "
                  >
                    <b>{{ $t("common.notes.note") }}:</b>
                    {{ $t("integrations.accessNote") }}
                  </p>
                </div>
              </div>
              <!-- <hr class="h-line" style="margin-top: 50px; margin-bottom: 42px" /> -->
            </div>
          </template>

          <template
            v-if="
              ((!getIntegId || getFromBack) &&
                allDirAreas &&
                allDirAreas.length > 0 &&
                option &&
                option.code == 'usersAndScans') ||
              (option && option.code == 'usersAndScans')
            "
          >
            <hr class="h-line" style="margin-top: 50px; margin-bottom: 42px" />
            <b-row>
              <b-col cols="5">
                <h6 class="dark-grey mapping-title">
                  {{ $t("emergencySessionsList.grid.areas") }}
                </h6>
              </b-col>
              <b-col cols="2"></b-col>
              <b-col cols="5">
                <h6 class="dark-grey-two mapping-title">
                  {{ $t("emergencySessionsList.grid.areas") }}
                </h6>
              </b-col>
            </b-row>
            <div
              v-for="(area, i) in allDirAreas"
              :key="area.area_id"
              class="d-flex justify-content-between mb-3 mapping-fields"
            >
              <template>
                <b-form-input
                  class="width-416"
                  :value="area.area_name"
                  readonly
                  :class="{
                    'disable-field':
                      getUsersWithDuplicatesCount > 0 ||
                      getUsersWithErrsCount > 0 ||
                      (getIntgData && getIntgData.can_edit),
                  }"
                />
                <!-- <b-input-group>
                  <b-form-select
                    v-model="area.bindValue"
                    @change="areaChangeHandler(area.area_id, $event, i)"
                    style="padding-inline-start: 20px"
                    class="width-422 height-55 mapping-select "
                    :class="{
                      'disable-field':
                        getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0,
                    }"
                    :disabled="
                      getIsEdit &&
                      (getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0)
                    "
                  >
                    <template v-for="item in allSitesAreas">
                      <b-form-select-option :key="item.area_id" :value="item.area_id"
                        >{{ item.area_name }}
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-input-group> -->
                <div class="field-con">
                  <vp-treeselect
                    v-model="area.bindValue"
                    @input="areaChangeHandler(area.area_id, $event, i)"
                    @select="selectHandler($event, area)"
                    :label="$t('integrations.selectArea')"
                    class="integration-dropdown"
                    :showPlaceholderIcon="false"
                    :options="allSitesAreas"
                    :isMultiple="false"
                    :width="'416'"
                    :disabled="
                      getIsEdit &&
                      (getUsersWithDuplicatesCount > 0 ||
                        getUsersWithErrsCount > 0 ||
                        !getIntgData.can_edit ||
                        (allSitesAreas.find(
                          (item) => item.id == area.bindValue
                        ) &&
                          allSitesAreas.find(
                            (item) => item.id == area.bindValue
                          ).isDisabled))
                    "
                  />
                  <p
                    class="removing-notAllawed-one"
                    v-if="
                      getIsEdit &&
                      allSitesAreas.find((item) => item.id == area.bindValue) &&
                      allSitesAreas.find((item) => item.id == area.bindValue)
                        .isDisabled
                    "
                  >
                    <strong class="bold-text"
                      >{{ $t("common.notes.note") }}:</strong
                    >
                    {{ $t("integrations.accessAreaNote") }}
                  </p>
                </div>
              </template>
            </div>
          </template>

          <hr class="h-line" style="margin-top: 50px; margin-bottom: 42px" />
          <b-row>
            <b-col cols="5">
              <h6 class="dark-grey mapping-title">
                {{
                  (this.getModalInfo && this.getModalInfo.code === "wonde") ||
                  this.getIntgData.dir_code === "wonde"
                    ? $t("integrations.grades")
                    : $t("integrations.groups")
                }}
              </h6>
            </b-col>
            <b-col cols="2"></b-col>
            <b-col cols="5">
              <h6
                class="dark-grey-two mapping-title"
                style="margin-inline-start: 202px"
              >
                {{ $t("announcements.grid.userTypes") }}
              </h6>
            </b-col>
          </b-row>
          <!-- <div class="mapping-fields-con"> -->
          <div
            v-for="(group, i) in groupTextFields"
            :key="group.id"
            class="d-flex justify-content-between mb-3 mapping-fields"
          >
            <!-- <div class="left-fields"> -->
            <!-- <button
              class="mapped-remove"
              v-if="
                getIsEdit &&
                groupTextFields.length > 1 &&
                getUsersWithDuplicatesCount == 0 &&
                getUsersWithErrsCount == 0
              "
              type="button"
              @click="removeGroup(group, i)"
            >
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5 0C5.13667 0 0 5.13667 0 11.5C0 17.8633 5.13667 23 11.5 23C17.8633 23 23 17.8633 23 11.5C23 5.13667 17.8633 0 11.5 0ZM17.3522 15.3844C17.8889 15.9211 17.8889 16.79 17.3522 17.3267C17.0711 17.6078 16.7389 17.7356 16.3811 17.7356C16.0233 17.7356 15.6656 17.6078 15.41 17.3267L11.5767 13.4933L7.71778 17.3267C7.43667 17.6078 7.10444 17.7356 6.74667 17.7356C6.38889 17.7356 6.03111 17.6078 5.77556 17.3267C5.23889 16.79 5.23889 15.9211 5.77556 15.3844L9.63445 11.5256L5.77556 7.69222C5.23889 7.15556 5.23889 6.28667 5.77556 5.75C6.31222 5.21333 7.18111 5.21333 7.71778 5.75L11.5767 9.60889L15.4356 5.75C15.9722 5.21333 16.8411 5.21333 17.3778 5.75C17.9144 6.28667 17.9144 7.15556 17.3778 7.69222L13.5189 11.5511L17.3522 15.3844Z"
                  fill="#F46A6A"
                />
              </svg>
            </button>
            <button
              class="mappegitd-remove"
              v-if="
                getIsEdit &&
                (groupTextFields.length == 1 ||
                  getUsersWithDuplicatesCount > 0 ||
                  getUsersWithErrsCount > 0)
              "
              type="button"
              disabled
            >
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="opacity: 0.7"
              >
                <path
                  d="M11.5 0C5.13667 0 0 5.13667 0 11.5C0 17.8633 5.13667 23 11.5 23C17.8633 23 23 17.8633 23 11.5C23 5.13667 17.8633 0 11.5 0ZM17.3522 15.3844C17.8889 15.9211 17.8889 16.79 17.3522 17.3267C17.0711 17.6078 16.7389 17.7356 16.3811 17.7356C16.0233 17.7356 15.6656 17.6078 15.41 17.3267L11.5767 13.4933L7.71778 17.3267C7.43667 17.6078 7.10444 17.7356 6.74667 17.7356C6.38889 17.7356 6.03111 17.6078 5.77556 17.3267C5.23889 16.79 5.23889 15.9211 5.77556 15.3844L9.63445 11.5256L5.77556 7.69222C5.23889 7.15556 5.23889 6.28667 5.77556 5.75C6.31222 5.21333 7.18111 5.21333 7.71778 5.75L11.5767 9.60889L15.4356 5.75C15.9722 5.21333 16.8411 5.21333 17.3778 5.75C17.9144 6.28667 17.9144 7.15556 17.3778 7.69222L13.5189 11.5511L17.3522 15.3844Z"
                  fill="#F46A6A"
                />
              </svg>
            </button> -->

            <b-form-input
              class="width-custom"
              id="custom-inputwidth"
              :value="group.name"
              readonly
              :class="{
                'disable-field':
                  getUsersWithDuplicatesCount > 0 ||
                  getUsersWithErrsCount > 0 ||
                  (getIntgData && getIntgData.can_edit),
              }"
            />
            <!-- <b-input-group>
              <b-form-select
                @change="groupChangeHanlder(group.id, $event, i)"
                class="height-55 mapping-select"
                v-model="group.bindValue"
                :class="{
                  'disable-field':
                    getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0,
                }"
                :disabled="
                  getIsEdit &&
                  (getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0)
                "
              >
                <template v-for="role in rolesItems">
                  <b-form-select-option :key="role.id" :value="role">
                    {{ role.label }}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-input-group> -->
            <div class="dropdown-n">
              <div
                v-if="
                  getIntgData.groups_mappings &&
                  getIntgData.groups_mappings.find(
                    (item) => item.dir_group_id == group.id
                  ) &&
                  getIntgData.groups_mappings.find(
                    (item) => item.dir_group_id == group.id
                  ).disabled
                "
              >
                <vp-input
                  v-model="
                    getIntgData.groups_mappings.find(
                      (item) => item.dir_group_id == group.id
                    ).role.name
                  "
                  :label="$t('integrations.selectUserType')"
                  :disabled="true"
                  width="416"
                />
              </div>
              <vp-treeselect
                v-else
                v-model="group.bindValue"
                @input="groupChangeHanlder(group.id, $event, i)"
                @select="selectHandler($event, group)"
                :label="$t('integrations.selectUserType')"
                class="integration-dropdown"
                :showPlaceholderIcon="false"
                :options="rolesItems"
                :isMultiple="false"
                :width="'416'"
                :disabled="
                  getIsEdit &&
                  (getUsersWithDuplicatesCount > 0 ||
                    getUsersWithErrsCount > 0 ||
                    !getIntgData.can_edit)
                "
              />
              <p
                class="removing-notAllawed-one"
                v-if="
                  getIsEdit &&
                  getIntgData.groups_mappings &&
                  getIntgData.groups_mappings.find(
                    (item) => item.dir_group_id == group.id
                  ) &&
                  getIntgData.groups_mappings.find(
                    (item) => item.dir_group_id == group.id
                  ).disabled
                "
              >
                <strong class="bold-text"
                  >{{ $t("common.notes.note") }}:</strong
                >
                {{ $t("integrations.accessUserNote") }}
              </p>
            </div>
          </div>

          <!-- </div> -->

          <div
            class="text-danger"
            v-if="submitted && !$v.form.rolesItemsArray.required"
          >
            <span class="font-weight-bolder">{{
              $t("integrations.oneGroup")
            }}</span>
          </div>

          <template>
            <hr class="h-line" style="margin-top: 50px; margin-bottom: 42px" />
            <div
              v-for="(staffGroupTextField, index) in staffGroupTextFields"
              :key="index"
            >
              <b-row>
                <b-col cols="5">
                  <h6 class="dark-grey mapping-title">
                    {{ $t("integrations.staffGroups") }}
                  </h6>
                </b-col>
                <b-col cols="2"></b-col>
                <b-col cols="5">
                  <h6 class="dark-grey-two mapping-title">
                    {{ $t("announcements.grid.userTypes") }}
                  </h6>
                </b-col>
              </b-row>
              <div
                v-for="(group, i) in staffGroupTextField.groups"
                :key="group.id"
                class="d-flex justify-content-between mb-3 mapping-fields"
              >
                <b-form-input
                  class="width-custom"
                  id="custom-inputwidth"
                  :value="group.name"
                  readonly
                  :class="{
                    'disable-field':
                      getUsersWithDuplicatesCount > 0 ||
                      getUsersWithErrsCount > 0 ||
                      (getIntgData && getIntgData.can_edit),
                  }"
                />
                <!-- <b-input-group>
                  <b-form-select
                    @change="staffGroupChangeHanlder(group.id, $event, i, index)"
                    class="height-55 mapping-select"
                    v-model="group.bindValue"
                    :class="{
                      'disable-field':
                        getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0,
                    }"
                    :disabled="
                      getIsEdit &&
                      (getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0)
                    "
                  >
                    <template v-for="role in rolesItems">
                      <b-form-select-option :key="role.id + 'Y' + group.id" :value="role">
                        {{ role.label }}
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-input-group> -->
                <div class="field-cont">
                  <div
                    v-if="
                      getIntgData.groups_mappings &&
                      getIntgData.groups_mappings.find(
                        (item) => item.dir_group_id == group.id
                      ) &&
                      getIntgData.groups_mappings.find(
                        (item) => item.dir_group_id == group.id
                      ).disabled
                    "
                  >
                    <vp-input
                      v-model="
                        getIntgData.groups_mappings.find(
                          (item) => item.dir_group_id == group.id
                        ).role.name
                      "
                      :label="$t('integrations.selectUserType')"
                      :disabled="true"
                      width="416"
                    />
                  </div>
                  <vp-treeselect
                    v-else
                    v-model="group.bindValue"
                    @input="staffGroupChangeHanlder(group.id, $event, i, index)"
                    @select="selectHandler($event, group)"
                    :label="$t('integrations.selectUserType')"
                    class="integration-dropdown"
                    :showPlaceholderIcon="false"
                    :options="rolesItems"
                    :isMultiple="false"
                    :width="'416'"
                    :disabled="
                      getIsEdit &&
                      (getUsersWithDuplicatesCount > 0 ||
                        getUsersWithErrsCount > 0 ||
                        !getIntgData.can_edit)
                    "
                  />
                  <p
                    class="removing-notAllawed-one"
                    v-if="
                      getIsEdit &&
                      getIntgData.groups_mappings &&
                      getIntgData.groups_mappings.find(
                        (item) => item.dir_group_id == group.id
                      ) &&
                      getIntgData.groups_mappings.find(
                        (item) => item.dir_group_id == group.id
                      ).disabled
                    "
                  >
                    <strong class="bold-text">
                      {{ $t("common.notes.note") }}:</strong
                    >
                    {{ $t("integrations.accessUserNote") }}
                  </p>
                </div>
              </div>

              <b-row>
                <b-col cols="5">
                  <h6 class="dark-grey mapping-title">
                    {{ $t("integrations.staffFields") }}
                  </h6>
                </b-col>
                <b-col cols="2"></b-col>
                <b-col cols="5">
                  <h6 class="dark-grey-two mapping-title">
                    {{ $t("integrations.userFields") }}
                  </h6>
                </b-col>
              </b-row>
              <div
                v-for="field in staffTextFields[index]"
                :key="field.id"
                class="d-flex justify-content-between mb-3 mapping-fields"
              >
                <b-input-group class="width-416">
                  <label
                    v-b-tooltip.hover
                    v-bind:title="field.display_Name"
                    :class="{
                      'disable-field':
                        getUsersWithDuplicatesCount > 0 ||
                        getUsersWithErrsCount > 0 ||
                        (getIntgData && getIntgData.can_edit),
                    }"
                  >
                    {{ field.display_Name }}
                  </label>
                  <b-form-input
                    v-b-tooltip.hover="field.example_data"
                    class="width-416"
                    :value="field.example_data"
                    readonly
                    :class="{
                      'disable-field':
                        getUsersWithDuplicatesCount > 0 ||
                        getUsersWithErrsCount > 0 ||
                        (getIntgData && getIntgData.can_edit),
                    }"
                  />
                </b-input-group>
                <!-- <b-form-select
                  @change="staffFieldChangeHanlder(field.id, $event, index)"
                  v-model="field.bindValue"
                  style="padding-inline-start: 20px"
                  class="width-422 height-55 mapping-select"
                  :class="{
                    'disable-field':
                      getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0,
                  }"
                  :disabled="
                    getIsEdit &&
                    (getUsersWithDuplicatesCount > 0 || getUsersWithErrsCount > 0)
                  "
                >
                  <template v-for="item in dropdownItems">
                    <b-form-select-option
                      :key="item.id"
                      :value="item.id"
                      :disabled="dropdownFieldsValues.includes(item.id)"
                      >{{ item.display_Name }}
                    </b-form-select-option>
                  </template>
                </b-form-select> -->
                <vp-treeselect
                  v-model="field.bindValue"
                  @input="staffFieldChangeHanlder(field.id, $event, index)"
                  @select="selectHandler($event, field)"
                  :label="$t('integrations.selectUser')"
                  class="integration-dropdown"
                  :showPlaceholderIcon="false"
                  :options="dropdownFieldItems"
                  :isMultiple="false"
                  :width="'416'"
                  :disabled="
                    getIsEdit &&
                    (getUsersWithDuplicatesCount > 0 ||
                      getUsersWithErrsCount > 0 ||
                      !getIntgData.can_edit)
                  "
                />
              </div>
            </div>
          </template>

          <div
            class="action-btns d-flex justify-content-center"
            style="margin-top: 118px; margin-bottom: 100px !important"
          >
            <button
              class="submit-btn btn btn-primary"
              size="md"
              type="submit"
              :disabled="
                getLoading ||
                $v.$invalid ||
                form.name.length > 30 ||
                selectedSite.length == 0 ||
                (option &&
                  option.code == 'usersAndScansAndAttendance' &&
                  !this.selectedArea) ||
                !!getErrMsg
              "
              v-if="!getIsEdit || getFromBack"
              @click="saveAndSync = false"
            >
              <i
                v-if="getLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
              ></i>
              <span>{{ $t("common.import") }}</span>
            </button>

            <div
              v-if="
                getIsEdit &&
                !getFromBack &&
                getIntgData &&
                getIntgData.status !== 'Expired'
              "
            >
              <button
                v-if="
                  option &&
                  option.code != 'usersAndScans' &&
                  option.code != 'usersAndScansAndAttendance'
                "
                class="submit-btn btn btn-primary"
                size="md"
                type="submit"
                :disabled="
                  getLoading ||
                  $v.$invalid ||
                  form.name.length > 30 ||
                  selectedSite.length == 0 ||
                  (option &&
                    option.code == 'usersAndScansAndAttendance' &&
                    !this.selectedArea) ||
                  !!getErrMsg
                "
                @click="saveAndSync = false"
              >
                <i
                  v-if="getLoading"
                  class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
                ></i>
                <span>{{ $t("common.save") }}</span>
              </button>

              <button
                class="submit-btn btn btn-primary"
                :class="{ 'custom-loader': true }"
                size="md"
                type="submit"
                :disabled="
                  getLoading ||
                  $v.$invalid ||
                  form.name.length > 30 ||
                  selectedSite.length == 0 ||
                  (option &&
                    option.code == 'usersAndScansAndAttendance' &&
                    !this.selectedArea) ||
                  !!getErrMsg
                "
                @click="saveAndSync = true"
              >
                <i
                  v-if="getLoading"
                  class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
                ></i>
                <span>{{ $t("integrations.saveAndSync") }}</span>
              </button>
            </div>
          </div>
        </b-form>
      </div>
    </section>

    <!-- warning  -->
    <b-modal
      id="mappingChangedWarning"
      class="popover-modal"
      hide-header
      hide-footer
      size="lg"
      no-close-on-esc
      ref="mappingChangedWarning"
    >
      <slot name="modal-header">
        <div class="modalHeader">
          <h4 class="modal-title">
            <slot name="modal-title"> {{ $t("common.warning") }} </slot>
          </h4>
        </div>
      </slot>
      <div class="d-block text-center modal-cusomContent">
        <p class="modal-paragraph">
          {{ $t("integrations.mappingChangedWarning") }}
        </p>
        <p class="modal-smallParagraph">
          {{ $t("integrations.byPressing")
          }}<span class="bold-word"> “{{ $t("common.cancel") }}” </span
          >{{ $t("integrations.allDataWillBeLost") }}
        </p>
      </div>
      <div class="line"></div>
      <div class="action-btns">
        <b-button
          variant="primary"
          type="button"
          pill
          :disabled="getLoading"
          style="margin-inline-end: 31px !important"
          class="text-center modal-buttonSize"
          @click="repeatImport()"
        >
          {{ $t("common.import") }}
        </b-button>

        <b-button
          variant="outline-danger"
          type="button"
          pill
          :disabled="getLoading"
          class="text-center modal-buttonSize"
          @click="resetFormWithIntgData()"
        >
          {{ $t("common.cancel") }}
        </b-button>
      </div>
    </b-modal>

    <!-- refresh  -->
    <b-modal
      id="refreshModal"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      ref="refreshModal"
    >
      <div class="d-flex loading-container">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="loader-content">
          <p>{{ $t("common.refreshing") }}</p>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import PageHeader from "@/components/page-header";
// import Dropdown from "@/components/integration/DirFieldsDropdown";
// import RoleDropdown from "@/components/integration/RolesDropdown";
// import Multiselect from "vue-multiselect";
import switches from "vue-switches";
import { mapGetters, mapActions } from "vuex";
import { required, requiredIf } from "vuelidate/lib/validators";

const filterObject = (obj, filter, filterValue) =>
  Object.keys(obj).reduce(
    (acc, val) =>
      obj[val][filter] === filterValue
        ? acc
        : {
            ...acc,
            [val]: obj[val],
          },
    {}
  );

export default {
  title: "Integrations",
  components: {
    PageHeader,
    // Dropdown,
    // RoleDropdown,
    // Multiselect,
    switches,
  },
  data() {
    return {
      savedLang: localStorage.getItem("language"),
      isLoading: false,
      editOption: null,
      option: null,
      allSitesAreas: [],
      allDirAreas: [],
      selected: null,
      submitted: false,
      saveAndSync: false,
      syncValue: 1,
      deletionValue: 1,
      syncedData: "",
      scanSettingVal: 2,
      title: "Integration Settings",
      sitesOptions: [],
      selectedSite: [],
      value: [],
      data: {},
      delete_handling: [],
      sync_settings: [],
      sync_options: [],
      scan_settings: [],
      textFields: [],
      staffTextFields: [],
      dropdownItems: [{ id: null, label: "Select User Field" }],
      dropdownFieldItems: [{ id: null, label: "Select User Field" }],
      dropdownItemsFinal: [{ id: null, label: "Select User Field" }],
      dirMapValues: {},
      staffFieldsValues: {},
      originalStaffFieldsValues: {},
      originalDirMapValues: {},
      rolesValues: {},
      areasValues: {},
      originalAreasValues: {},
      originalRolesValues: {},
      groupTextFields: [],
      staffGroupTextFields: [],
      rolesItems: [{ id: null, label: "Select User Type" }],
      formData: {},
      sites: [],
      values: {},
      form: {
        name: "",
        // selectedSite: [],
        dirMapValuesArray: [],
        rolesItemsArray: [],
        areasItemsArray: [],
        staffFieldsValuesArray: [],
      },

      // photos settings
      hasPhotosSettings: false,
      sync_photos: 0,
      syncPhotosValue: 0,
      validate_photos: [],
      validatePhotoValue: 0,
      import_photo_action: [],
      importPhotoActionValue: 0,
      write_back: 0,
      writeBackValue: 0,
      autoWriteBackValue: 0,
      automatic_write: [],

      // areas dropdowns
      areasDropdownItems: [{ value: null, text: "Select Area" }],
      selectedArea: null,
    };
  },
  validations: {
    form: {
      name: {
        required,
        // maxLength: maxLength(30),
      },
      // selectedSite: {
      //   required,
      // },
      dirMapValuesArray: {
        required,
      },
      rolesItemsArray: {
        required,
      },
      areasItemsArray: {
        required: requiredIf(function () {
          return this.option && this.option.code === "usersAndScans";
        }),
      },
      staffFieldsValuesArray: {
        required: requiredIf(function () {
          return (
            (this.getModalInfo && this.getModalInfo.code === "wonde") ||
            this.getIntgData.dir_code === "wonde"
          );
        }),
      },
    },
  },
  watch: {
    selectedArea(area) {
      // console.log('selectedArea watch', area);
      let obj = {
        params: {
          site_ids: this.selectedSite,
        },
      };
      if (
        this.option.code == "usersAndScansAndAttendance" &&
        this.selectedSite?.length
      ) {
        if (area) obj.params.area_ids = [area];
        this.fetchUserTypesBySitesIds(obj).then((data) => {
          setTimeout(() => {
            (this.rolesItems = [{ id: "", label: "Select User Type" }]),
              data.data.map((item) => {
                this.rolesItems.push({
                  id: item.id,
                  label: item.label,
                  children: item.children,
                });
              });
          }, 0);
        });
      }
    },
    getSelectedSitesAreas(areas) {
      console.log("getSelectedSitesAreas", areas);
      setTimeout(() => {
        this.allSitesAreas = JSON.parse(JSON.stringify(areas));
      }, 500);
      // this.allSitesAreas.map(item => {
      //   item.label = item.name;
      // });
      // if (this.getIsEdit) this.allSitesAreas.splice(0, 1);
      if (this.getIsEdit || this.getFromBack) {
        const area = this.getSelectedSitesAreas.find(
          (item) =>
            item.area_id ==
            (this.getIntgData.areas_mappings &&
            this.getIntgData.areas_mappings[0]
              ? this.getIntgData.areas_mappings[0].cloud_area_id
              : null)
        );
        this.selectedArea =
          this.getIntgData.areas_mappings &&
          this.getIntgData.areas_mappings[0] &&
          area
            ? // { area_id:
              this.getIntgData.areas_mappings[0].cloud_area_id
            : //   area_name: area.area_name,
              // }
              null;
        // { area_id: null, area_name: "Select Area" };
      }
      const areaExist = this.getSelectedSitesAreas.find(
        (item) => item.area_id == this.selectedArea
      );
      if (!areaExist) this.selectedArea = null;

      if (this.allDirAreas && this.allDirAreas.length > 0) {
        // this.allDirAreas.map((area) => {
        // const areaExist = this.allSitesAreas.find(
        //   (item) => item.id == area.bindValue
        // );
        // area.bindValue = areaExist ? areaExist.id : null;
        // if (!areaExist) {
        // this.areasValues[area.area_id].cloud_area_id = areaExist?.area_id;
        // }
        // });
        this.form.areasItemsArray = Object.values(this.areasValues);

        this.form.areasItemsArray = this.form.areasItemsArray.filter(
          (item) => !!item.cloud_area_id
        );
      }
    },
    getDirAreas(areas) {
      // console.log('areas', areas);
      this.allDirAreas = [];
      if (areas && areas.length > 0)
        areas.forEach((item) => {
          this.allDirAreas.push({
            area_id: item.area_id,
            area_name: item.area_name,
            id: item.area_id,
            label: item.area_name,
            doors_count: item.doors_count,
            bindValue: null,
          });
        });
      console.log(
        "watch dirareas",
        this.allDirAreas,
        this.getSelectedSitesAreas
      );
    },
    syncedData(syncedData) {
      // console.log("syncedData");
      let editOption;
      const option = (this.option =
        this.data.sync_options.dir_sync_options.find(
          (item) => item.id == syncedData
        ));
      console.log("option", option);

      let obj = {
        params: {
          site_ids: this.selectedSite,
        },
      };
      if (
        (this.option.code == "usersAndScansAndAttendance" ||
          this.option.code == "usersAndScans") &&
        this.selectedSite?.length
      ) {
        if (this.selectedArea) obj.params.area_ids = [this.selectedArea];
        this.fetchUserTypesBySitesIds(obj).then((data) => {
          setTimeout(() => {
            (this.rolesItems = [{ id: "", label: "Select User Type" }]),
              data.data.map((item) => {
                this.rolesItems.push({
                  id: item.id,
                  label: item.label,
                  children: item.children,
                });
              });
          }, 0);
        });
      } else {
        setTimeout(() => {
          (this.rolesItems = [{ id: "", label: "Select User Type" }]),
            // console.log("rolesss", this.data.roles);
            this.data.roles.map((item) => {
              this.rolesItems.push({
                id: item.id,
                label: item.label,
                children: item.children,
              });
            });
        }, 0);
      }

      // if (
      //   (this.getModalInfo && this.getModalInfo.code === "wonde") ||
      //   this.getIntgData.dir_code === "wonde"
      // ) {
      //   this.editOption = this.data.sync_options.dir_sync_options.find(
      //     (item) => item.id == syncedData
      //   );
      // }

      if (!this.getIsEdit) {
        this.editOption = this.option;
        // console.log("editOption", editOption);
      }

      if (this.getIsEdit) {
        const optionId =
          this.getIsEdit && this.getIntgData.dir_int_sync_options[0]
            ? this.getIntgData.dir_int_sync_options[0].option_id
            : null;
        editOption = this.editOption =
          this.data.sync_options.dir_sync_options.find(
            (item) => item.id == optionId
          );
        console.log("editOption", this.editOption);
        if (
          !editOption ||
          editOption.code == "usersAndScans" ||
          editOption.code == "usersAndScansAndAttendance"
        )
          return;
        // else if (
        //   option &&
        //   option.code == "usersAndScans" &&
        //   editOption &&
        //   editOption.code != "usersAndScans"
        // ) {
        // this.allSitesAreas.splice(0, 0, {
        //   area_id: null,
        //   area_name: "Select Area",
        // });
        // }
      } else if (
        this.getIntgData.dir_areas &&
        this.getIntgData.dir_areas.length > 0
      )
        return;

      this.allDirAreas = [];
      if (
        option.code == "usersAndScans" ||
        option.code == "usersAndScansAndAttendance"
      ) {
        const data = {};
        const config =
          this.getIntgData &&
          this.getIntgData.configs &&
          !this.getIsExtraScenario
            ? this.getIntgData.configs
            : this.getConfigData;
        config.map((item) => {
          data[item.key_code] = item.value;
        });
        // console.log(this.getModalInfo, this.getConfigData, data, this.getIntgData);
        this.fetchDirAreas({ code: this.getModalInfo.code, data });

        const dir_code =
          this.getIntgData && this.getIntgData.dir_code
            ? this.getIntgData.dir_code
            : this.getModalInfo.code;
        const dir_id =
          this.getIntgData && this.getIntgData.dir_id
            ? this.getIntgData.dir_id
            : this.getModalInfo.id;
        if (dir_code == "paxton" || dir_code == "wonde") {
          this.isLoading = true;

          this.fetchSelectedSitesAreas({
            dir_id,
            selectedSites: this.selectedSite,
          }).then(() => {
            this.isLoading = false;
          });
        }
      } else {
        this.areasValues = {};
        this.form.areasItemsArray = null;
      }
    },
    getLoading(value) {
      if (!value) this.$bvModal.hide("mappingChangedWarning");
    },
    deletionValue(value) {
      console.log("deletionValue", value);
    },
    form(form) {
      console.log("forn", form);
    },
    getErrMsg(getErrMsg) {
      console.log("getErrMsg", getErrMsg);
    },
    selectedSite: {
      handler() {
        // const selectedSitesIds = this.selectedSite.map((site) => site.id);
        const dir_id =
          this.getIntgData && this.getIntgData.dir_id
            ? this.getIntgData.dir_id
            : this.getModalInfo.id;

        const dir_code =
          this.getIntgData && this.getIntgData.dir_code
            ? this.getIntgData.dir_code
            : this.getModalInfo.code;

        if (dir_code == "paxton" || dir_code == "wonde") {
          this.isLoading = true;

          this.fetchSelectedSitesAreas({
            dir_id,
            selectedSites: this.selectedSite,
          }).then(() => {
            this.isLoading = false;
          });
        }
      },
      immediate: true,
    },
    dropdownFieldsValues: {
      handler(data) {
        console.log("dropdownFieldsValues handler", data);
        this.dropdownFieldItems = [];
        this.dropdownItems.map((item) => {
          this.dropdownFieldItems.push({
            ...item,
            isDisabled: data.includes(item.id),
          });
        });
        // setTimeout(() => {
        //   this.dropdownItems = [{id: 1, label: "hi", isDisabled: true}];
        // }, 0)
        console.log(
          "this.dropdownItems",
          this.dropdownItems,
          this.dropdownFieldItems
        );
      },
    },
    dropdownValues: {
      handler(data) {
        this.dropdownItemsFinal = [];
        this.dropdownItems.map((item) => {
          this.dropdownItemsFinal.push({
            ...item,
            isDisabled: data.includes(item.id),
          });
        });
      },
    },
    // getIntgData(data) {
    //   if (data) this.resetFormWithIntgData();
    // },
  },
  methods: {
    ...mapActions("integration", [
      "manageIntegrationSettings",
      "editIntegrationSettings",
      "updateIntegrationSettingsAndSync",
      "createConfigData",
      "fetchSelectedSitesAreas",
      "setIsExtraScenario",
      "createIntegration",
      "getIntegration",
      "createIntegrationForPendingStatus",
      "fetchDirAreas",
      "getUserTypes",
      "refreshMapping",
      "editIntegration",
      // "getIntegration",
      "checkNameValidation",
    ]),
    ...mapActions("userType", ["fetchUserTypesBySitesIds"]),
    areaChanged() {
      if (!this.selectedArea) {
        setTimeout(() => {
          this.selectedArea = null;
        }, 10);
      }
    },
    selectHandler(e, group) {
      if (!e.id) {
        setTimeout(() => {
          group.bindValue = null;
        }, 10);
      }
    },
    validateName(name) {
      const obj = {
        name,
      };
      if (this.getIsEdit || this.getFromBack) obj.intId = this.getIntegId;
      this.checkNameValidation(obj);
    },
    siteChanged() {
      console.log("sitechanged", this.selectedSite, this.getSelectedSitesAreas);
    },
    // getSelected(dir_field_id) {
    //   console.log("gg", dir_field_id);
    //   const mapFound = this.getIntgDataCopy.fields_mappings.find(
    //     (item) => item.dir_field_id == dir_field_id
    //   );
    //   if (mapFound) return mapFound.cloud_field_id;
    //   return this.dirMapValues[dir_field_id]
    //     ? this.dirMapValues[dir_field_id]
    //     : null;
    // },
    // getSelectedGroups(dir_group_id) {
    //   console.log("getSelectedGroups", dir_group_id);
    //   const mapFound = this.getIntgDataCopy.groups_mappings.find(
    //     (item) => item.dir_group_id == dir_group_id
    //   );
    //   console.log("mapFound", mapFound);
    //   if (mapFound)
    //     return { id: mapFound.cloud_role_id, name: mapFound.dir_group_name };
    //   return { id: null, name: "Select User Type" };
    // },
    onRefreshMapping() {
      console.log("refreshMapping");
      this.$bvModal.show("refreshModal");
      this.editIntegration(this.getIntegId).then(() => {
        this.resetMappingConfig();
        this.resetAreaMapping();
      });
      // this.refreshMapping(this.getIntegId).then((data) => {
      //   console.log("refresh manage", data);
      // });
    },
    removeGroup(group, i) {
      this.formData.is_mapping_change = 1;
      console.log(
        "remove grp",
        group,
        i,
        this.form.rolesItemsArray[0].dir_group_name == group.name
      );
      delete this.rolesValues[group.id];

      this.groupTextFields.splice(i, 1);
      const groupExist = this.form.rolesItemsArray.find(
        (item) => item.dir_group_name == group.name
      );
      if (groupExist) {
        const index = this.form.rolesItemsArray.indexOf(groupExist);
        this.form.rolesItemsArray.splice(index, 1);
      }
      // console.log('found', this.form.rolesItemsArray);
    },
    onSubmit() {
      (this.submitted = true), this.$v.$touch();
      if (this.form.name.length > 30) return;
      if (!this.$v.$invalid) {
        this.submitForm();
      }
    },
    dropdownChangeHanlder(inputId, dropdownId) {
      // console.log("handler", inputId, dropdownId);
      this.dirMapValues = {
        ...this.dirMapValues,
        [inputId]: {
          dir_field_id: inputId,
          cloud_field_id: dropdownId,
        },
      };
      this.dirMapValues = filterObject(
        this.dirMapValues,
        "cloud_field_id",
        null
      );
      this.form.dirMapValuesArray = Object.values(this.dirMapValues);
      this.form.dirMapValuesArray = this.form.dirMapValuesArray.filter(
        (item) => !!item.cloud_field_id
      );
    },

    groupChangeHanlder(inputId, role, i) {
      console.log(inputId, role, this.groupTextFields, i);
      // const roleName = this.rolesItems.find((item) => item.id == roleId);
      this.rolesValues = {
        ...this.rolesValues,
        [inputId]: {
          cloud_role_id: role,
          // cloud_role_name: role.name,
          dir_group_id: inputId,
          dir_group_name: this.groupTextFields[i].name,
        },
      };
      this.rolesValues = filterObject(this.rolesValues, "cloud_role_id", null);
      this.form.rolesItemsArray = Object.values(this.rolesValues);
      console.log("this.form.rolesItemsArray", this.form.rolesItemsArray);
      this.form.rolesItemsArray = this.form.rolesItemsArray.filter(
        (item) => !!item.cloud_role_id
      );
    },

    staffGroupChangeHanlder(inputId, role, i, index) {
      console.log(
        "staffGroupChangeHanlder",
        inputId,
        role,
        this.staffGroupTextFields,
        i
      );
      this.rolesValues = {
        ...this.rolesValues,
        [inputId]: {
          cloud_role_id: role,
          dir_group_id: inputId,
          dir_group_name: this.staffGroupTextFields[index].groups[i].name,
        },
      };
      this.rolesValues = filterObject(this.rolesValues, "cloud_role_id", null);
      this.form.rolesItemsArray = Object.values(this.rolesValues);
      this.form.rolesItemsArray = this.form.rolesItemsArray.filter(
        (item) => !!item.cloud_role_id
      );
      console.log("this.form.rolesItemsArray", this.form.rolesItemsArray);
    },

    staffFieldChangeHanlder(inputId, dropdownId, i) {
      console.log("handler", inputId, dropdownId, this.staffGroupTextFields[i]);
      this.staffFieldsValues = {
        ...this.staffFieldsValues,
        [inputId]: {
          dir_field_id: inputId,
          cloud_field_id: dropdownId,
          extra_type: this.staffGroupTextFields[i].id,
        },
      };
      // console.log('staffFieldsValues', this.staffFieldsValues);
      this.staffFieldsValues = filterObject(
        this.staffFieldsValues,
        "cloud_field_id",
        null
      );
      console.log("staffFieldsValues", this.staffFieldsValues);
      this.form.staffFieldsValuesArray = Object.values(this.staffFieldsValues);
      this.form.staffFieldsValuesArray =
        this.form.staffFieldsValuesArray.filter(
          (item) => !!item.cloud_field_id
        );
      console.log(
        "this.form.staffFieldsValuesArray",
        this.form.staffFieldsValuesArray
      );
    },

    areaChangeHandler(inputId, area, i) {
      console.log("areachangehandler", inputId, area, i);
      const areas =
        this.getIntgData && this.getIntgData.dir_areas
          ? this.getIntgData.dir_areas
          : this.allDirAreas;
      const selectedArea = areas.find((item) => item.area_id == inputId);
      this.areasValues = {
        ...this.areasValues,
        [inputId]: {
          cloud_area_id: area,
          dir_area_id: inputId,
          dir_area_name: this.allDirAreas[i].area_name,
          dir_doors_number: selectedArea.doors_count,
        },
      };
      this.areasValues = filterObject(this.areasValues, "cloud_area_id", null);
      this.form.areasItemsArray = Object.values(this.areasValues);
      this.form.areasItemsArray = this.form.areasItemsArray.filter(
        (item) => !!item.cloud_area_id
      );
      console.log("this.form.areasItemsArray", this.form.areasItemsArray);
      if (this.option.code == "usersAndScans" && this.selectedSite?.length) {
        let obj = {
          params: {
            site_ids: this.selectedSite,
          },
        };
        if (this.form.areasItemsArray && this.form.areasItemsArray.length)
          obj.params.area_ids = this.form.areasItemsArray.map((item) => {
            return item.cloud_area_id;
          });
        this.fetchUserTypesBySitesIds(obj).then((data) => {
          setTimeout(() => {
            (this.rolesItems = [{ id: "", label: "Select User Type" }]),
              data.data.map((item) => {
                this.rolesItems.push({
                  id: item.id,
                  label: item.label,
                  children: item.children,
                });
              });
          }, 0);
        });
      }
    },

    repeatImport() {
      this.formData.is_mapping_change = 1;
      // console.log('repeat', this.formData);
      // edit and import again
      if (this.getIntegId) {
        // edit and redirect to errors / duplicate / valid users
        if (!this.saveAndSync)
          this.editIntegrationSettings({
            data: this.formData,
            isEdit: this.getIsEdit,
          });
        else {
          console.log("saveAndSync");
          this.updateIntegrationSettingsAndSync({
            data: this.formData,
            isEdit: this.getIsEdit,
          });
        }
      } else {
        // create new integration
        this.manageIntegrationSettings(this.formData);
      }
    },

    submitForm() {
      this.sites = this.selectedSite.map((item) => {
        return {
          site_id: item,
        };
      });
      // console.log("hello", this.getModalInfo, this.getIntgData, this.sites);

      this.formData = {
        dir_unique_id: this.data.dir_unique_id,
        id: this.getIntegId,
        is_mapping_change: 0,
        is_fields_mapping_change: 0,
        dir_id:
          this.getIntgData && this.getIntgData.dir_id
            ? this.getIntgData.dir_id
            : this.getModalInfo.id,
        dir_code:
          this.getIntgData && this.getIntgData.dir_code
            ? this.getIntgData.dir_code
            : this.getModalInfo.code,
        entity_id: this.currentEntity.id,
        name: this.form.name,
        configs:
          this.getIntgData &&
          this.getIntgData.configs &&
          !this.getIsExtraScenario
            ? this.getIntgData.configs
            : this.getConfigData,
        sites: this.sites,
        sync_setting: {
          sync_time:
            this.option && this.option.code == "usersAndScansAndAttendance"
              ? 4
              : this.syncValue,
        },
        delete_user_setting: {
          delete_handle: this.deletionValue,
        },
        fields_mappings: this.form.dirMapValuesArray,
        groups_mappings: this.form.rolesItemsArray,
        areas_mapping:
          this.option && this.option.code == "usersAndScans"
            ? this.form.areasItemsArray
            : null,
        extra_data: [],
        created_by: JSON.parse(localStorage.getItem("userDetails")).id,
        write_back_settings: null,
        user_scan_settings: null,
      };

      // in case of wonde, return only the selected cloud area
      if (this.option && this.option.code == "usersAndScansAndAttendance") {
        this.formData.areas_mapping = [
          {
            dir_area_id: "default_int_area_id",
            dir_area_name: "default_area_name",
            dir_doors_number: "1",
            cloud_area_id: this.selectedArea,
          },
        ];

        this.formData.write_back_settings = {
          auto_write: this.autoWriteBackValue,
          active: this.writeBackValue,
        };
      }

      this.formData.photo_settings = {
        validate_photos: this.validatePhotoValue,
        import_photo_action: this.importPhotoActionValue,
        active: this.syncPhotosValue,
      };

      if (
        this.data.sync_options &&
        this.data.sync_options.dir_sync_options &&
        this.data.sync_options.dir_sync_options.length > 0
      ) {
        this.formData.sync_options = [
          {
            option_id:
              this.data.sync_options.dir_sync_options.length > 1
                ? this.syncedData
                : this.data.sync_options.dir_sync_options[0].id,
          },
        ];
      } else if (this.data.sync_options) {
        this.formData.sync_options = this.data.sync_options;
      }

      if (this.formData.dir_code == "wonde") {
        this.formData.user_scan_settings = [
          {
            option_id: this.scanSettingVal,
          },
        ];
      }

      if (this.staffGroupTextFields && this.staffGroupTextFields.length > 0) {
        let extra_settings_options = [];
        this.staffGroupTextFields.forEach((item) => {
          console.log(
            "this.form.staffFieldsValuesArray",
            this.form.staffFieldsValuesArray
          );
          const mappings = this.form.staffFieldsValuesArray.filter(
            (field) => field.extra_type == item.id
          );
          // console.log('mappings', mappings);
          let arr = [];
          mappings.forEach((mapping) => {
            arr.push({
              cloud_field_id: mapping.cloud_field_id,
              dir_field_id: mapping.dir_field_id,
            });
          });
          extra_settings_options.push({
            extra_type: item.id,
            settings_obj: JSON.stringify(arr),
          });
        });
        console.log("extra_settings_options", extra_settings_options);
        this.formData.extra_settings_options = extra_settings_options;
      }
      console.log(
        "formData",
        this.formData,
        this.getIntegId,
        this.rolesValues,
        this.originalRolesValues
      );
      if (
        this.getIntegId &&
        (JSON.stringify(this.originalRolesValues) !==
          JSON.stringify(this.rolesValues) ||
          JSON.stringify(this.originalDirMapValues) !==
            JSON.stringify(this.dirMapValues) ||
          JSON.stringify(this.originalAreasValues) !==
            JSON.stringify(this.areasValues) ||
          (this.getIntgData.dir_code == "wonde" &&
            (this.getIntgData.areas_mappings[0]?.cloud_area_id !=
              this.selectedArea ||
              JSON.stringify(this.originalStaffFieldsValues) !==
                JSON.stringify(this.staffFieldsValues))))
      ) {
        if (
          JSON.stringify(this.originalDirMapValues) !==
            JSON.stringify(this.dirMapValues) ||
          (this.getIntgData.dir_code == "wonde" &&
            JSON.stringify(this.originalStaffFieldsValues) !==
              JSON.stringify(this.staffFieldsValues))
        ) {
          this.formData.is_fields_mapping_change = 1;
        }
        console.log(
          "check",
          JSON.stringify(this.originalStaffFieldsValues) !==
            JSON.stringify(this.staffFieldsValues)
        );
        console.log("mapping changed", this.getIsEdit, this.getFromBack);
        this.formData.is_mapping_change = 1;
        // if (!this.getIsExtraScenario) {
        if (this.getIsEdit || this.getFromBack) {
          this.$bvModal.show("mappingChangedWarning");
          return;
        }
        // }
      }
      if ((this.getIntegId && this.getIsEdit) || this.getFromBack) {
        // edit and redirect to errors / duplicate / valid users
        if (!this.saveAndSync)
          this.editIntegrationSettings({
            data: this.formData,
            isEdit: this.getIsEdit,
          });
        else {
          console.log("saveAndSync");
          this.updateIntegrationSettingsAndSync({
            data: this.formData,
            isEdit: this.getIsEdit,
          });
        }
      } else if (!this.getIsEdit) {
        if (this.getModalInfo.code == "googleAD")
          this.formData.extra_data.push({
            email: this.getDecryptedEmail,
          });
        // create new integration
        if (this.getIsExtraScenario) {
          this.createIntegrationForPendingStatus(this.formData);
          return;
        }
        this.manageIntegrationSettings(this.formData);
      }
    },

    resetFormWithIntgData() {
      this.$bvModal.hide("mappingChangedWarning");
      this.data = this.getCreatedIntegration;
      console.log("jdjdjd", this.data);
      this.delete_handling = [];
      this.sync_settings = [];
      this.sync_options = [];
      this.scan_settings = [];
      (this.sync_photos = this.data.sync_options.sync_photos),
        (this.validate_photos = []);
      this.import_photo_action = [];
      this.write_back = this.data.sync_options.write_back;

      this.data.delete_handling.map((item) => {
        this.delete_handling.push({
          text: Object.values(item)[0],
          value: +Object.keys(item)[0],
        });
      });

      this.data.sync_options.dir_sync_options.map((item) => {
        this.sync_options.push({
          text: item.name,
          value: item.id,
        });
      });

      this.data.sync_options.dir_user_scan_settings.map((item) => {
        this.scan_settings.push({
          text: item.name,
          value: item.option_id,
        });
      });

      this.data.sync_settings.map((item) => {
        this.sync_settings.push({
          text: Object.values(item)[0],
          value: +Object.keys(item)[0],
        });
      });

      this.data.validate_photos.forEach((item) => {
        this.validate_photos.push({
          text: Object.keys(item)[0],
          value: Object.values(item)[0],
        });
      });
      this.data.import_photo_action.forEach((item) => {
        this.import_photo_action.push({
          text: Object.values(item)[0],
          value: +Object.keys(item)[0],
        });
      });
      this.data.auto_write_back.forEach((item) => {
        this.automatic_write.push({
          text: Object.keys(item)[0],
          value: Object.values(item)[0],
        });
      });
      this.sitesOptions = this.data.sites;
      this.sitesOptions.map((item) => {
        item.label = item.name;
        const siteFound = this.getIntgData?.sites?.find(
          (site) => site.id == item.id
        );
        if (siteFound && siteFound.disabled) item.isDisabled = true;
        else item.isDisabled = false;
      });
      this.getIntgData?.sites?.map((site) => {
        const siteExist = this.sitesOptions.find((item) => item.id == site.id);
        if (site.disabled && !siteExist)
          this.sitesOptions.push({
            id: site.id,
            label: site.name,
            isDisabled: site.disabled,
          });
      });

      this.syncedData = this.sync_options[0].value;
      this.scanSettingVal = 2;
      this.importPhotoActionValue = this.import_photo_action[0].value;

      if (this.getIsEdit || this.getFromBack) {
        console.log("getIntgData edit", this.getIntgData);
        this.syncValue = this.getIntgData.sync_setting.sync_time;
        this.deletionValue = this.getIntgData.delete_user_setting.delete_handle;
        this.syncedData = this.getIntgData.dir_int_sync_options[0]
          ? this.getIntgData.dir_int_sync_options[0].option_id
          : 0;
        this.scanSettingVal = this.getIntgData.dir_int_user_scan_settings[0]
          ? this.getIntgData.dir_int_user_scan_settings[0].option_id
          : 2;

        this.selectedArea =
          this.getIntgData.areas_mappings && this.getIntgData.areas_mappings[0]
            ? this.getIntgData.areas_mappings[0].cloud_area_id
            : null;

        if (this.getIntgData.dir_photo_setting !== null) {
          const photoSettings = this.getIntgData.dir_photo_setting;

          this.validatePhotoValue = photoSettings.validate_photos;
          this.importPhotoActionValue = photoSettings.import_photo_action;
          this.syncPhotosValue = photoSettings.active;
        }

        if (this.getIntgData.dir_write_back_setting !== null) {
          const writeBackSettings = this.getIntgData.dir_write_back_setting;

          this.autoWriteBackValue = writeBackSettings.auto_write;
          this.writeBackValue = writeBackSettings.active;
        }

        this.form = {
          name: this.getIntgData.name,
          // selectedSite: [],
          dirMapValuesArray: [],
          rolesItemsArray: [],
          areasItemsArray: [],
          staffFieldsValuesArray: [],
        };
        console.log("getIntgData", this.getIntgData);
        this.selectedSite = this.getIntgData.sites.map((item) => {
          return item.id;
        });
      }

      this.resetMappingConfig();
    },

    resetMappingConfig() {
      this.originalDirMapValues = {};
      this.dirMapValues = {};
      this.staffFieldsValues = {};
      this.originalDirMapValues = {};
      this.rolesValues = {};
      this.dropdownItems =
        this.dropdownFieldItems =
        this.dropdownItemsFinal =
          [{ id: "", label: "Select User Field" }];
      this.groupTextFields = [];
      this.textFields = [];
      this.staffTextFields = [];
      this.allSitesAreas = [];
      this.staffGroupTextFields = [];

      // mapping fields configuration
      if (this.data.fields_mapping) {
        const fieldsMappingArray = this.data.fields_mapping;
        console.log("dfdfdf", this.dropdownFieldsValues);
        fieldsMappingArray.forEach((item) => {
          if (item.type === "system") {
            setTimeout(() => {
              this.dropdownItems.push({
                id: item.id,
                label: item.display_Name,
              });
              this.dropdownFieldItems.push({
                id: item.id,
                label: item.display_Name,
                isDisabled: this.dropdownFieldsValues.includes(item.id),
              });
              this.dropdownItemsFinal.push({
                id: item.id,
                label: item.display_Name,
                isDisabled: this.dropdownValues.includes(item.id),
              });
            }, 0);
          } else {
            // console.log('gggg', this.getIntgData)
            const mapFound =
              this.getIntgData && this.getIntgData.fields_mappings
                ? this.getIntgData.fields_mappings.find(
                    (dropdownItem) => dropdownItem.dir_field_id == item.id
                  )
                : null;
            this.textFields.push({
              ...item,
              bindValue: mapFound ? mapFound.cloud_field_id : null,
            });
          }
        });

        let staffTextFields = [];
        if (
          this.data.extra_settings_options &&
          this.data.extra_settings_options[0]
        ) {
          this.data.extra_settings_options.forEach((option, index) => {
            fieldsMappingArray.forEach((item) => {
              if (item.type !== "system") {
                const staffMapFound =
                  this.getIntgData &&
                  this.getIntgData.dir_int_extra_settings &&
                  this.getIntgData.dir_int_extra_settings[index]
                    ? JSON.parse(
                        this.getIntgData.dir_int_extra_settings[index]
                          .settings_obj
                      ).find(
                        (dropdownItem) => dropdownItem.dir_field_id == item.id
                      )
                    : null;
                staffTextFields.push({
                  ...item,
                  bindValue: staffMapFound
                    ? staffMapFound.cloud_field_id
                    : null,
                });
              }
            });
            this.staffTextFields.push(staffTextFields);
          });
        }
      }

      // mapping groups configuration
      if (this.data.roles) {
        const option = (this.option =
          this.data.sync_options.dir_sync_options.find(
            (item) => item.id == this.syncedData
          ));
        if (
          (option?.code == "usersAndScansAndAttendance" ||
            option?.code == "usersAndScans") &&
          this.selectedSite?.length
        ) {
          let obj = {
            params: {
              site_ids: this.selectedSite,
            },
          };
          if (option?.code == "usersAndScansAndAttendance" && this.selectedArea)
            obj.params.area_ids = [this.selectedArea];
          else if (
            option?.code == "usersAndScans" &&
            this.form.areasItemsArray &&
            this.form.areasItemsArray.length
          )
            obj.params.area_ids = this.form.areasItemsArray.map((item) => {
              return item.cloud_area_id;
            });
          this.fetchUserTypesBySitesIds(obj).then((data) => {
            setTimeout(() => {
              (this.rolesItems = [{ id: "", label: "Select User Type" }]),
                data.map((item) => {
                  this.rolesItems.push({
                    id: item.id,
                    label: item.label,
                    children: item.children,
                  });
                });
            }, 0);
          });
        } else {
          setTimeout(() => {
            (this.rolesItems = [{ id: "", label: "Select User Type" }]),
              // console.log("rolesss", this.data.roles);
              this.data.roles.map((item) => {
                this.rolesItems.push({
                  id: item.id,
                  label: item.label,
                  children: item.children,
                });
              });
          }, 0);
        }
      }
      if (this.data.groups) {
        // if (this.data.groups.length == 0) { // in case of edit integration
        //   this.getIntgData.groups_mappings.forEach((item) => {
        //     this.groupTextFields.push({
        //       id: item.dir_group_id,
        //       name: item.dir_group_name,
        //       bindValue: { id: item.role.id, name: item.role.name },
        //     });
        //   });
        // }

        this.data.groups.forEach((item) => {
          // all dir_groups
          const mapFound =
            this.getIntgData && this.getIntgData.groups_mappings
              ? this.getIntgData.groups_mappings.find(
                  (dropdownItem) => dropdownItem.dir_group_id == item.id
                )
              : null;
          this.groupTextFields.push({
            id: item.id,
            name: item.name,
            bindValue: mapFound ? mapFound.cloud_role_id : null,
          });
        });
      }
      if (
        this.getIntgData.cloud_areas &&
        this.getIntgData.cloud_areas.length > 0
      ) {
        this.allSitesAreas = JSON.parse(
          JSON.stringify(this.getIntgData.cloud_areas)
        );
        this.allSitesAreas.map((item) => {
          item.label = item.area_name;
          item.id = item.area_id;
        });
        // this.allSitesAreas.splice(0, 0, {
        //     area_id: null,
        //     area_name: "Select Area",
        //   });
      }
      if (
        this.getIntgData &&
        this.getIntgData.dir_areas &&
        this.getIntgData.dir_areas.length > 0
      ) {
        this.getIntgData.dir_areas.forEach((item) => {
          // const mapFound = this.getIntegId && this.getIsEdit
          //   ? this.getIntgData.areas_mappings.find(
          //     (dropdownItem) => dropdownItem.cloud_area_id == item.id
          //   )
          //   : null;
          const areaExist = this.getIntgData.areas_mappings.find(
            (area) => area.dir_area_id == item.area_id
          );
          this.allDirAreas.push({
            area_id: item.area_id,
            area_name: item.area_name,
            doors_count: item.doors_count,
            bindValue: areaExist ? areaExist.cloud_area_id : null,
            originalBindValue: areaExist ? areaExist.cloud_area_id : null,
          });
        });
        console.log("this.allDirAreas", this.allDirAreas);

        // this.getIntgData.cloud_areas.forEach((item) => {
        // const mapFound = this.getIntegId
        //   ? this.getIntgData.areas_mappings.find(
        //       (dropdownItem) => dropdownItem.cloud_area_id == item.id
        //     )
        //   : null;
        // if (mapFound) {
        //   const selectedArea = this.allDirAreas.find(
        //     (area) => area.area_id == mapFound.dir_area_id
        //   );

        //   console.log('mapfp', mapFound);

        //   selectedArea.bindValue =
        //     mapFound.cloud_area_id;
        //     // area_name: item.name,

        //   selectedArea.originalBindValue =
        //     mapFound.cloud_area_id;
        //     // area_name: item.name,

        // }
        // });
      }

      if (
        this.data.extra_settings_options &&
        this.data.extra_settings_options[0]
      ) {
        let staffGroups = [];
        this.data.extra_settings_options.forEach((item) => {
          const userTypes = JSON.parse(item.condition).user_type;
          console.log("userTypes", userTypes);
          userTypes.forEach((userType) => {
            const mapFound =
              this.getIntgData && this.getIntgData.groups_mappings
                ? this.getIntgData.groups_mappings.find(
                    (dropdownItem) => dropdownItem.dir_group_id == userType
                  )
                : null;
            const userTypeExist = this.groupTextFields.find(
              (group) => group.id == userType
            );
            const index = this.groupTextFields.indexOf(userTypeExist);
            this.groupTextFields.splice(index, 1);
            if (userTypeExist) {
              staffGroups.push({
                id: userType,
                name: userTypeExist.name,
                bindValue: mapFound ? mapFound.cloud_role_id : null,
              });
            }
          });
          this.staffGroupTextFields.push({ id: item.id, groups: staffGroups });
          console.log("staffGroupTextFields", this.staffGroupTextFields);
        });
      }

      // is Edit
      if (this.getIsEdit || this.getFromBack) {
        this.getIntgData.areas_mappings.forEach((item) => {
          this.originalAreasValues = {
            ...this.originalAreasValues,
            [item.dir_area_id]: {
              cloud_area_id: item.cloud_area_id,
              dir_area_id: +item.dir_area_id,
              dir_area_name: item.dir_area_name,
              dir_doors_number: item.dir_doors_number,
            },
          };
        });
        this.getIntgData.groups_mappings.forEach((item) => {
          this.originalRolesValues = {
            ...this.originalRolesValues,
            [item.dir_group_id]: {
              cloud_role_id: item.cloud_role_id,
              dir_group_id: item.dir_group_id,
              dir_group_name: item.dir_group_name,
            },
          };
        });
        this.getIntgData.fields_mappings.forEach((item) => {
          this.originalDirMapValues = {
            ...this.originalDirMapValues,
            [item.dir_field_id]: {
              dir_field_id: item.dir_field_id,
              cloud_field_id: item.cloud_field_id,
            },
          };
        });

        if (
          this.getIntgData.dir_int_extra_settings &&
          this.getIntgData.dir_int_extra_settings.length > 0
        ) {
          this.getIntgData.dir_int_extra_settings.forEach((setting) => {
            JSON.parse(setting.settings_obj).forEach((item) => {
              this.originalStaffFieldsValues = {
                ...this.originalStaffFieldsValues,
                [item.dir_field_id]: {
                  dir_field_id: +item.dir_field_id,
                  cloud_field_id: +item.cloud_field_id,
                  extra_type: setting.extra_type,
                },
              };
            });
          });
        }

        if (
          this.getIntgData.areas_mappings &&
          this.getIntgData.areas_mappings.length > 0
        ) {
          this.getIntgData.areas_mappings.forEach((item) => {
            this.areasValues = {
              ...this.areasValues,
              [item.dir_area_id]: {
                cloud_area_id: item.cloud_area_id,
                dir_area_id: +item.dir_area_id,
                dir_area_name: item.dir_area_name,
                dir_doors_number: item.dir_doors_number,
              },
            };
          });
          this.form.areasItemsArray = Object.values(this.areasValues);

          this.form.areasItemsArray = this.form.areasItemsArray.filter(
            (item) => !!item.cloud_area_id
          );
          console.log(
            ".areasItemsArrayyyy",
            this.form.areasItemsArray,
            this.areasValues
          );
        }

        this.getIntgData.groups_mappings.forEach((item) => {
          this.rolesValues = {
            ...this.rolesValues,
            [item.dir_group_id]: {
              cloud_role_id: item.cloud_role_id,
              dir_group_id: item.dir_group_id,
              dir_group_name: item.dir_group_name,
            },
          };
        });
        this.form.rolesItemsArray = Object.values(this.rolesValues);
        console.log(".rolesItemsArray", this.form.rolesItemsArray);
        this.form.rolesItemsArray = this.form.rolesItemsArray.filter(
          (item) => !!item.cloud_role_id
        );

        this.getIntgData.fields_mappings.forEach((item) => {
          this.dirMapValues = {
            ...this.dirMapValues,
            [item.dir_field_id]: {
              dir_field_id: item.dir_field_id,
              cloud_field_id: item.cloud_field_id,
            },
          };
        });
        this.form.dirMapValuesArray = Object.values(this.dirMapValues);
        this.form.dirMapValuesArray = this.form.dirMapValuesArray.filter(
          (item) => !!item.cloud_field_id
        );

        if (
          this.getIntgData.dir_int_extra_settings &&
          this.getIntgData.dir_int_extra_settings.length > 0
        ) {
          this.getIntgData.dir_int_extra_settings.forEach((setting) => {
            JSON.parse(setting.settings_obj).forEach((item) => {
              this.staffFieldsValues = {
                ...this.staffFieldsValues,
                [item.dir_field_id]: {
                  dir_field_id: +item.dir_field_id,
                  cloud_field_id: +item.cloud_field_id,
                  extra_type: setting.extra_type,
                },
              };
            });
          });
          this.staffFieldsValues = filterObject(
            this.staffFieldsValues,
            "cloud_field_id",
            null
          );
          console.log("staffFieldsValues", this.staffFieldsValues);
          this.form.staffFieldsValuesArray = Object.values(
            this.staffFieldsValues
          );
          this.form.staffFieldsValuesArray =
            this.form.staffFieldsValuesArray.filter(
              (val) => !!val.cloud_field_id
            );
          // console.log("hiii", this.staffFieldsValues, this.form.staffFieldsValuesArray);
        }
        setTimeout(() => {
          ////////refresh ///////
          this.$bvModal.hide("refreshModal");
        }, 1000);
      }
    },

    resetAreaMapping() {
      this.allDirAreas = [];
      // console.log('resetAreaMapping', this.option);
      if (
        this.option.code == "usersAndScans" ||
        this.option.code == "usersAndScansAndAttendance"
      ) {
        const data = {};
        const config =
          this.getIntgData &&
          this.getIntgData.configs &&
          !this.getIsExtraScenario
            ? this.getIntgData.configs
            : this.getConfigData;
        config.map((item) => {
          data[item.key_code] = item.value;
        });
        // console.log(this.getModalInfo, this.getConfigData, data);
        this.fetchDirAreas({ code: this.getModalInfo.code, data });
      } else {
        this.areasValues = {};
        this.form.areasItemsArray = null;
      }

      const area = this.getSelectedSitesAreas.find(
        (item) =>
          item.area_id ==
          (this.getIntgData.areas_mappings && this.getIntgData.areas_mappings[0]
            ? this.getIntgData.areas_mappings[0].cloud_area_id
            : null)
      );
      this.selectedArea =
        this.getIntgData.areas_mappings &&
        this.getIntgData.areas_mappings[0] &&
        area
          ? // { area_id:
            this.getIntgData.areas_mappings[0].cloud_area_id
          : //   area_name: area.area_name,
            // }
            null;
      // { area_id: null, area_name: "Select Area" };

      const areaExist = this.getSelectedSitesAreas.find(
        (item) => item.area_id == this.selectedArea
      );
      if (!areaExist) this.selectedArea = null;
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("integration", [
      "getIntegId",
      "getCreatedIntegration",
      "getIntgData",
      "getLoading",
      "getConfigData",
      "getUsersWithDuplicatesCount",
      "getUsersWithErrsCount",
      "getIsEdit",
      "getFromView",
      "getFromBack",
      "getErrMsg",
      "getDecryptedEmail",
      "getSelectedSitesAreas",
      "getIsExtraScenario",
      "getDirAreas",
    ]),
    ...mapGetters("authfack", ["currentEntity"]),
    dropdownValues() {
      return Object.values(this.dirMapValues)
        .filter((item) => !!item.cloud_field_id)
        .map((item) => item.cloud_field_id);
    },
    dropdownFieldsValues() {
      return Object.values(this.staffFieldsValues)
        .filter((item) => !!item.cloud_field_id)
        .map((item) => item.cloud_field_id);
    },
  },
  beforeMount() {
    document.getElementById("preloader").style.display = "none";
    document.getElementById("status").style.display = "none";
    this.$store.commit("integration/setErrMsg", "");
  },
  mounted() {
    // if(this.getIsEdit) this.getIntegration({ id: this.getIntegId });
    console.log(
      "getIntegId",
      this.getIsEdit,
      this.getIntegId,
      this.getIntgData,
      this.sitesOptions
    );
    // if (!this.getIsEdit || this.getFromBack) {
    //   this.rolesItems.push({ id: null, name: "Select User Type" });
    // }
    console.log(this.getModalInfo);

    if (this.getIsEdit) {
      this.getIntegration({ id: this.getIntegId }).then((res) => {
        const obj = {};
        const integrationConfigs = res.configs;
        integrationConfigs.forEach((config) => {
          obj[config.key_code] = config.value;
        });
        obj.dir_int_id = this.getIntegId;
        this.createIntegration({
          directory_type: this.getModalInfo.code,
          obj,
          isExtraScenario: this.getIsExtraScenario,
          hideToaster: true,
        }).then(() => {
          this.resetFormWithIntgData();
        });
        const configData = integrationConfigs.map((item) => {
          return {
            key_id: item.key_id,
            value: item.value,
            key_code: item.key_code,
          };
        });
        // console.log('configData',configData);
        this.createConfigData(configData);
      });
    } else this.resetFormWithIntgData();
    // this.getIntgDataCopy = JSON.parse(JSON.stringify(this.getIntgData));

    // mapping field configuration

    // this.groupTextFields = this.data.groups;
  },
  created() {},
};
</script>
<style lang="scss" scoped>
span.int-span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // padding-inline-start: 5px;
  // padding-inline-end: 5px;
}
p.removing-notAllawed-one {
  color: var(--939393, #939393);

  font-size: 14px;

  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.25px;
  margin-top: 8px;
  margin-inline-start: 20px;
  width: 374px;
  margin-bottom: 0px;
}
.bold-text {
  color: var(--939393, #939393);
}
// .text-danger.border{
//   border: 1.5px solid #F46A6A!important;
// border-radius: 4px!important;

// }

// .err-wrapper{
//   margin-top:-28px;
//   margin-bottom: 24px;
// }
.form-group.m-d-gruop {
  margin-bottom: 24px !important;
}
.refresh-btn {
  background: #103f5e;
  border-radius: 16.6px;
  width: 111px;
  height: 33px;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  margin-inline-start: 47px;
  svg {
    margin-inline-end: 5px;
    margin-bottom: 2px;
  }
}

.mappegitd-remove {
  background: transparent;
  border: none;
}
.mapped-remove {
  background: transparent;
  border: none;
}
p.access-permission {
  color: #939393;

  font-size: 16px;

  font-weight: 700;
  line-height: normal;
  margin-bottom: 16px;
}
p.admin-permission {
  color: var(--939393, #939393);

  font-size: 14px;

  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.25px;
  margin-bottom: 24px;
}
.font-weight-bolder {
  font-weight: 600 !important;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.25px;
  color: #f46a6a;
  padding-inline-start: 20px !important;
}

a {
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-decoration-line: underline !important;
  color: #103f5e !important;
}

.note {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.25px;
  color: #939393;
  padding: 26px 0 38px 0;
}

.note-center {
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.25px;
  color: #939393;

  padding: 26px 0 38px 0;
  text-align: center;
}

.light-grey {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #c7c7c7;
}

h4.upper-case {
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;
  text-transform: uppercase !important;
  color: #000000 !important;
}

label.intName {
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;

  color: rgba(96, 96, 96, 0.87) !important;

  opacity: 0.8 !important;
}

label.intName.itnName-type {
  font-weight: 700 !important;
  font-size: 12px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;
  color: #103f5e !important;
  opacity: 1 !important;
}

.width-32 {
  width: 32%;
}

.width-42 {
  width: 39%;
}

.width-40 {
  width: 40%;
}
.width-416 {
  width: 416px;
}
.width-custom {
  width: 416px !important;
  // margin-inline-end: 185px;
}
input#custom-inputwidth {
  width: 416px !important;
}
.width-45 {
  width: 45%;
}

.disable-field {
  background: #f2f2f2 !important;
  opacity: 0.6 !important;
  border-radius: 4px !important;

  label {
    opacity: 0.2 !important;
  }

  input {
    opacity: 0.2 !important;
  }

  .form-control {
    opacity: 0.2 !important;
  }
}

.height-55 {
  width: 442px !important;
  height: 55px;

  font-weight: 700;
  font-size: 16px;
  line-height: 17px;
  letter-spacing: 0.25px;
  background: #f2f2f2
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px;
  border: none;
  color: #787878;
  border-radius: 4px;
}

.input-group {
  width: 416px !important;
}

.dark-grey-mapping,
.dark-grey-synced,
.dark-grey-directory,
.dark-grey-handling,
.dark-grey-photo {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #939393;
}
.dark-grey-synced {
  margin-bottom: 32px !important;
}
.dark-grey-directory,
.dark-grey-handling,
.dark-grey-photo {
  margin-bottom: 20px !important;
}
h6.dark-grey-two.mapping-title {
  margin-inline-start: 40px;
  color: #787878;

  font-size: 16px;

  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
}
h6.dark-grey.mapping-title {
  // margin-inline-start: 40px;
  color: #787878;

  font-size: 16px;

  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
}
.mapping-fields {
  label {
    background-color: #f2f2f2;
    width: 110px;
    height: 55px;
    // margin-inline-end: 15px;
    border-radius: 7px;
    text-align: center;
    color: #787878;
    font-size: 16px;
    font-weight: 700;
    margin-inline-end: 16px;
    // padding-top: 15px;
    // padding-inline-start: 20px;
    // padding-inline-end: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    // display: inline;
    position: relative;
  }

  input {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
  }

  .form-control {
    height: 55px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 290px;
    // padding: 20px;

    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.mapping-select .custom-select {
  padding: 40px;
  background-color: #50a5f1 !important;
}

.field-map-wrap {
  .key-field {
    display: inline-block;
    background-color: #f2f2f2;
    height: 57px;
    margin-inline-end: 5px;
    padding: 14px 15px;
    border-radius: 4px;
    color: #787878;
    font-size: 16px;
  }

  .input-wrapper {
    display: inline-block;
    width: 100%;
  }
}

.wrapper {
  background-color: white;
  padding-inline-start: 30px;
  padding-top: 32px;
  border-radius: 5px;
  padding-bottom: 30px;
  padding-inline-end: 30px;

  .content {
    margin-top: 0px;
  }
}

.form-control {
  background-color: #f2f2f2;
  border-color: #f2f2f2;
}

.custom-tag .form-control {
  background-color: white;
  border: 0px;
  padding: 0px;
}

.custom-tag .form-control .custom-select {
  background-color: #f2f2f2;
  border-color: #f2f2f2;
  color: #797d91;
  width: 31.7%;
}

.mdi-arrow-right-box {
  font-size: 30px !important;
  padding: 0px !important;
  color: #000000;
  position: absolute;
  bottom: 0;
  inset-inline-end: 90px;
}

@import "@/design/user_form_modals.scss";

.change-text {
  text-decoration: underline !important;
  color: #50a5f1;
}

.delete-icon {
  font-size: 1.3rem;
  margin-inline-start: 8px;
  cursor: pointer;
}

.user-types-select {
  z-index: 1100;
}

.user-roles {
  z-index: 999;
}

p {
  display: block;
  color: #939393;
}

.header-close {
  font-size: 24px !important;
  font-weight: bold !important;
  background-color: transparent;
  border: none;
}

.header-close:active {
  outline: none;
}

h5.modal-title {
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}
</style>

<style lang="scss">
.integration-wrapper .integration-dropdown .vp-ml-52 {
  margin-inline-start: 19px !important;
}
input#integrationName {
  height: 39px !important;
  .text-danger {
    margin-bottom: 24px !important;
    margin-top: -24px !important;
  }
}

.int-selectarea {
  .multiselect__tags {
    height: 55px;
    background: #f2f2f2 !important;
    border-radius: 4px;
    border: none !important;
  }
  input#int-site {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    margin-top: 10px !important;

    letter-spacing: 0.25px;

    color: #787878;
  }
  span.multiselect__single {
    background: #f2f2f2 !important;

    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    margin-top: 10px;

    letter-spacing: 0.25px;

    color: #787878;
  }
  .multiselect__select {
    z-index: 3;
    top: 7px !important;
  }
}
.int-dropDown {
  .multiselect__select:before {
    top: 85%;
  }
  .multiselect--active {
    .multiselect__select:before {
      top: 35%;
    }
  }
  .vue-treeselect__multi-value {
    margin-inline-start: 0px !important;
  }
}
input#int-site {
  background: transparent !important;
}
.int-dropDown .multiselect__placeholder {
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  color: #787878 !important;

  margin-top: 10px;
  margin-inline-start: 7px;
}
.int-site .multiselect__content-wrapper {
  display: none;
}
.int-dropDown {
  .multiselect__tags {
    min-height: 55px !important;
    // background: red!important;
    display: grid !important;
  }
  .multiselect__tag {
    &:first-child {
      margin-top: 25px;
    }
  }
}
.int-site,
.int-selectarea {
  position: relative;
}
.selections-label {
  position: absolute;
  color: #103f5e;
  margin-top: 10px;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: 20px;
  z-index: 100;

  font-size: 12px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-align: start;
}

input#int-site::placeholder {
  font-weight: 400 !important;
  font-size: 16px;
  line-height: 17px;
  /* identical to box height, or 106% */
  background: transparent !important;
  letter-spacing: 0.25px !important;

  color: rgba(96, 96, 96, 0.87) !important;

  opacity: 0.8;
}

.int-site {
  .multiselect {
    z-index: 10;
    .multiselect__input {
      background: #f2f2f2 !important;
    }
    .multiselect__placeholder {
      font-weight: 400 !important;
      font-size: 16px;
      line-height: 17px;
      padding-inline-start: 10px;

      letter-spacing: 0.25px;

      color: rgba(96, 96, 96, 0.87) !important;

      opacity: 0.8;
    }
    .multiselect__tag {
      font-size: 16px !important;
      line-height: 17px !important;

      font-weight: 700 !important;
      letter-spacing: 0.25px !important;
      padding-top: 10px !important;
      padding-inline-end: 48px !important;
      padding-bottom: 12px !important;
      padding-inline-start: 20px !important;
      border-radius: 6px !important;
      &:first-child {
        margin-top: 25px;
      }
      .multiselect__tag-icon:after {
        font-size: 22px;
      }
      i.multiselect__tag-icon {
        width: 32px;
        font-size: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      i.multiselect__tag-icon:hover {
        background: #f46a6a;
      }
    }
  }
}
.vue-switcher--unchecked div:after {
  inset-inline-start: 15px;
  background: #939393 !important;
  // height: 21px;
  // width: 21px;
  // margin-top: 3px;
}
.vue-switcher div:after {
  background: #34c38f;
  // height: 21px;
  // width: 21px;
  // margin-top: 3px;
}
label.vue-switcher.vue-switcher--unchecked.vue-switcher-theme--bootstrap,
label.vue-switcher.vue-switcher-theme--bootstrap.vue-switcher-color--none {
  background: #f0f0f0;
  border-radius: 13.5px;
  // height: 21px;
  // width: 21px;
}
div#mappingChangedWarning___BV_modal_content_ {
  width: 579px !important;
  // height: 324px !important;
  padding: bottom 0px !important;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  margin-top: 150px;
  h4.modal-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    text-align: start;
    margin-bottom: 35px !important;
  }

  .modal-paragraph {
    font-weight: 400;
    font-size: 20px !important;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #939393;
    width: 494px;
  }

  .modal-smallParagraph {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #939393;
    margin-bottom: 21px !important;

    .bold-word {
      font-weight: 700 !important;
    }
  }

  .line {
    width: 488.16px !important;
    height: 1px !important;
    opacity: 0.15;
    background: #707070;
  }

  .modal-buttonSize {
    width: 111.69px !important;
    height: 33.26;
    margin-top: 20px !important;
    // margin-bottom: 19.75px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.invalid-field {
  .form-control {
    background-color: transparent !important;
    border-color: transparent !important;
    //     & .form-control{
    //     height: 39px!important;
    // }
  }
}

.form-group.m-d-gruop.invalid-field {
  margin-bottom: 12px !important;
}

.submit-btn.btn.btn-primary.custom-loader {
  width: 120px;
}
.submit-btn.btn.btn-primary:disabled {
  cursor: not-allowed;
}

.int-dropDown {
  width: 442px !important;

  .multiselect__tags {
    background-color: #f2f2f2 !important;
    border: none !important;
  }

  input#site {
    background-color: #f2f2f2 !important;
  }

  span.multiselect__tag {
    font-size: 16px !important;
    line-height: 17px !important;

    font-weight: 700 !important;
    letter-spacing: 0.25px !important;
    padding-top: 10px !important;
    padding-inline-end: 48px !important;
    padding-bottom: 12px !important;
    padding-inline-start: 20px !important;
    border-radius: 6px !important;
  }

  .multiselect__tag-icon {
    width: 33px;
    margin-inline-start: 0px !important;
  }

  .multiselect__tag-icon:hover {
    background: #f46a6a !important;
    border-radius: 6px !important;
  }

  i.multiselect__tag-icon::after {
    font-size: 22px !important;
    line-height: 20px !important;

    font-weight: 700 !important;
    letter-spacing: 0.25px !important;
    top: 23% !important;
    position: absolute;
    inset-inline-end: 30% !important;
  }

  .multiselect__placeholder {
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    color: #787878 !important;
  }
}

.content ul {
  margin-inline-start: 0 !important;
}

.flex-column {
  position: relative;
}

.mapping-title {
  padding-bottom: 30px !important;
  padding-inline-start: 20px !important;
  padding-top: 40px !important;
}

div#refreshModal___BV_modal_content_ {
  background: white;
  border: none;
  // height: 85px !important;
  width: 291px !important;
  border-radius: 60px;
  margin-top: 50%;
  // inset-inline-start: 20%;
  div#refreshModal___BV_modal_body_ {
    padding-top: 19px !important;
    padding-inline-end: 36px !important;
    padding-bottom: 19px !important;
    padding-inline-start: 30px !important;
    .loading-container {
      p {
        font-weight: 700;
        font-size: 16px;
        color: #000000;
        margin-bottom: 0px;
        margin-top: 7px;
        line-height: 152%;
      }
    }
    .spinner-border {
      color: #103f5e;
      border-width: 0.35em;
      width: 38px;
      height: 38px;
      margin-inline-end: 20px;
      border-right-color: #d9d9d9;
    }
  }
}
</style>
